import { render } from "./c-custom-select.vue?vue&type=template&id=c5a73f8e"
import script from "./c-custom-select.vue?vue&type=script&setup=true&lang=js"
export * from "./c-custom-select.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/luqiao/display/c-custom-select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5a73f8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5a73f8e', __exports__)) {
    api.reload('c5a73f8e', __exports__)
  }
  
  module.hot.accept("./c-custom-select.vue?vue&type=template&id=c5a73f8e", () => {
    api.rerender('c5a73f8e', render)
  })

}


export default __exports__